import type { RefObject } from "react";
import type { MembershipProduct } from "../SpaceType";
import { sortMembershipProductsForHome } from "../spacePageUtils";
import { SpaceHomeMembershipCard } from "./SpaceHomeMembershipCard";
import { spaceHomeMembershipSubscribeSectionCssVars } from "./SpaceHomeMembershipActiveTagConfig";

/** 权益订阅：瀑布流最后一个区块 */
export function SpaceHomeSubscribeCards(props: {
  spaceId: string;
  products: MembershipProduct[];
  isLoggedIn: boolean;
  sectionHintRef: RefObject<HTMLParagraphElement>;
  onLoginRequest: () => void;
}) {
  const { spaceId, products, isLoggedIn, sectionHintRef, onLoginRequest } = props;
  const sortedProducts = sortMembershipProductsForHome(products);
  if (sortedProducts.length === 0) {
    return null;
  }
  return (
    <section
      className="space-home-feed__section"
      aria-label="权益订阅"
      style={spaceHomeMembershipSubscribeSectionCssVars()}
    >
      <p ref={sectionHintRef} className="space-home-feed__section-hint">
        权益订阅
      </p>
      <ul className="space-home-sub-group" aria-label="会员产品列表">
        {sortedProducts.map((row) => (
          <SpaceHomeMembershipCard
            key={row.spaceProductId}
            row={row}
            spaceId={spaceId}
            isLoggedIn={isLoggedIn}
            onLoginRequest={onLoginRequest}
          />
        ))}
      </ul>
    </section>
  );
}
